import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, notification } from 'antd';
import {
	CenterWrapper,
	Logo,
	Title,
	XCheckbox,
	XCustomFloatLabel,
	XForm,
	XLottie,
	XThemeLottieCard,
} from './LoginStyle';
import {
	XContainer,
	XButton,
	XThemeContainer,
	XThemeGradientButton,
} from '../../styles/GlobalThemeStyle';
import { Input, Button } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import LoginAnimation from '../../json/Reclaim.json'; 
import { loginApi, loginReset } from '../../actions/loginAction';
import { handleInputChange } from '../../utils/formFunctions';
import {
	checkModulePermissions,
	getExpiresAt,
	getFirstAvailableRoute,
	isLogin,
} from '../../utils/helper';
import { requestPermissionAndGetToken } from '../../firebase/firebase';
import {
	XTheme2Button,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';

const Login = (props) => {
	const { login, loginReset, loginState } = props;
	const [form] = XForm.useForm();
	const [formData, setFormData] = useState({});
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		if (isLogin()) {
			let expiresAt = getExpiresAt();
			if (expiresAt !== null && new Date() < new Date(expiresAt))
				navigate('/');
		}
	}, []);

	const generateFcmToken = async () => {
		await requestPermissionAndGetToken();
	};

	useEffect(() => {
		if (loginState.apiState === 'success') {
			setLoading(false);
			localStorage.setItem('user_id', loginState.data.id);
			localStorage.setItem('accessToken', loginState.data.accessToken);
			localStorage.setItem('refreshToken', loginState.data.refreshToken);
			localStorage.setItem('username', loginState.data.username);
			localStorage.setItem('email', loginState.data.email);
			localStorage.setItem('profile', loginState.data.profile_image);
			localStorage.setItem('expiresAt', loginState.data.expiresAt);
			localStorage.setItem('role', loginState.data.role.role);
			localStorage.setItem(
				'org_logo',
				loginState.data.organization_logo || '',
			);
			localStorage.setItem(
				'changePassword',
				loginState.data.changePassword,
			);
			localStorage.setItem(
				'permissions',
				JSON.stringify(loginState.data.permissions),
			);
			localStorage.setItem(
				'dashboardData',
				JSON.stringify(loginState.data.dashboardData),
			);
			// Set login timestamp for dashboard loader detection
			localStorage.setItem('loginTimestamp', Date.now().toString());

			generateFcmToken();
			loginReset();
			if (loginState.data.changePassword) {
				navigate('/consent');
			} else {
				navigate('/');
			}
			// Check permissions after login
			const dashboardPermission = checkModulePermissions('dashboard');
			const nanodashboardPermission =
				checkModulePermissions('nano-dashboard');
			console.log('Dashboard Permission: ', dashboardPermission);
			if (
				dashboardPermission.authorized ||
				nanodashboardPermission.authorized
			) {
				navigate('/');
			} else {
				const firstAvailableRoute = getFirstAvailableRoute();
				navigate(firstAvailableRoute ? firstAvailableRoute.path : '/');
			}
		} else if (loginState.apiState === 'error') {
			setLoading(false);
			notification.error({ message: loginState.message });
			loginReset();
		}
	}, [loginState]);

	useEffect(() => {
		document.body.classList.add('bodyOverflowHideImageBg');
		return () => {
			document.body.classList.remove('bodyOverflowHideImageBg');
		};
	}, []);

	return (
		<XThemeContainer fluid>
			<Row className="align-items-center my-5" gutter={[15, 15]}>
				<Col xs={24} className="d-flex justify-content-start">
					<span className="logo">
						<img
							width={100}
							src={'/images/reclaim-revolution-logo.svg'}
							alt="logo"
						/>
						{/* Reclaim */}
					</span>
				</Col>
			</Row>
			<CenterWrapper className="align-items-center h-auto">
				<Row className="align-items-center w-100">
					<Col
						xs={{ span: 24, offset: 0 }}
						sm={{ span: 24, offset: 0 }}
						md={{ span: 12, offset: 6 }}
						lg={{ span: 6, offset: 9 }}
					>
						<div className="w-50 m-auto text-center">
							<XThemeLottieCard>
								<XLottie
									animationData={LoginAnimation}
									loop={true}
								/>
							</XThemeLottieCard>
						</div>

						<XTheme2MainTitle className="my-4 text-center">
							Welcome Back
						</XTheme2MainTitle>
						{/* <Logo>
							<img
								className="img-fluid"
								src="./images/logo.svg"
								alt="logo"
							/>
						</Logo> */}
						{/* <Title className="my-4">
							Welcome to Medicare Coverage Analysis Platform..
						</Title> */}
						<XForm
							form={form}
							name="loginForm"
							layout="vertical"
							autoComplete="off"
							onFinish={() => {
								setLoading(true);
								login(formData);
							}}
							className="w-100"
						>
							<XForm.Item
								name="email"
								// label="Email Address"
								rules={[
									{
										required: true,
										message: 'Please enter email address',
									},
								]}
							>
								<Input
									size={'large'}
									name="email"
									placeholder="Enter Email Address"
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XForm.Item>
							<XForm.Item
								name="password"
								// label="Password"
								rules={[
									{
										required: true,
										message: 'Please enter password',
									},
								]}
							>
								<Input.Password
									name="password"
									size={'large'}
									placeholder="Enter Password"
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XForm.Item>
							<XForm.Item className="d-flex justify-content-center">
								{/* <XForm.Item
									name="remember"
									valuePropName="checked"
									noStyle
								>
									<XCheckbox>Keep me signed in</XCheckbox>
								</XForm.Item> */}
								<Link
									className="login-form-forgot"
									to="/forgot-email-password"
									style={{
										color: '#007299',
										textDecoration: 'none',
									}}
								>
									Forgot password?
								</Link>
							</XForm.Item>

							<XForm.Item className="mt-4">
								{loading ? (
									<XTheme2Button
										className="w-100 py-4"
										type="primary"
										loading
									>
										Logging In...
									</XTheme2Button>
								) : (
									<XTheme2Button
										className="w-100 py-4"
										htmlType="submit"
									>
										Log In
									</XTheme2Button>
								)}
							</XForm.Item>
						</XForm>
					</Col>
					{/* <Col
						xs={{ span: 24, order: 1 }}
						sm={{ span: 24, order: 1 }}
						lg={{ span: 12, offset: 3, order: 2 }}
						className="text-center"
					>
						<Logo className="mobileLogo">
							<img
								className="img-fluid"
								src="./images/logo.svg"
								alt="logo"
							/>
						</Logo>
						<XThemeLottieCard className="mobileCard">
							<XLottie
								animationData={LoginAnimation}
								loop={true}
							/>
						</XThemeLottieCard>
					</Col> */}
				</Row>
			</CenterWrapper>
		</XThemeContainer>
	);
};

const mapStateToProps = (state) => ({
	loginState: state.login,
});

const mapDispatchToProps = (dispatch) => ({
	login: (params) => dispatch(loginApi(params)),
	loginReset: () => dispatch(loginReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
